// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.documenttype.knowntypes

import org.multipaz.cbor.DataItem
import org.multipaz.documenttype.knowntypes.PaymentTransaction.MitOptions
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.toDataItem

fun MitOptions.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "I2hOSs1DJCBnHZDwiH9V90PO0-VmL-ImXD9pVsoHZnE")
val MitOptions_cborSchemaId = ByteString(35, 104, 78, 74, -51, 67, 36, 32, 103, 29, -112, -16, -120, 127, 85, -9, 67, -50, -45, -27, 102, 47, -30, 38, 92, 63, 105, 86, -54, 7, 102, 113)

fun MitOptions.Companion.fromCbor(data: ByteArray): MitOptions {
    return MitOptions.fromDataItem(Cbor.decode(data))
}

val MitOptions.Companion.cborSchemaId: ByteString
    get() = MitOptions_cborSchemaId

fun MitOptions.toDataItem(): DataItem {
    val builder = CborMap.builder()
    val amountVariable = this.amountVariable
    if (amountVariable != null) {
        builder.put("amountVariable", amountVariable.toDataItem())
    }
    val minAmount = this.minAmount
    if (minAmount != null) {
        builder.put("minAmount", minAmount.toDataItem())
    }
    val maxAmount = this.maxAmount
    if (maxAmount != null) {
        builder.put("maxAmount", maxAmount.toDataItem())
    }
    val totalAmount = this.totalAmount
    if (totalAmount != null) {
        builder.put("totalAmount", totalAmount.toDataItem())
    }
    val initialAmount = this.initialAmount
    if (initialAmount != null) {
        builder.put("initialAmount", initialAmount.toDataItem())
    }
    val initialAmountNumber = this.initialAmountNumber
    if (initialAmountNumber != null) {
        builder.put("initialAmountNumber", initialAmountNumber.toDataItem())
    }
    val apr = this.apr
    if (apr != null) {
        builder.put("apr", apr.toDataItem())
    }
    return builder.end().build()
}

fun MitOptions.Companion.fromDataItem(dataItem: DataItem): MitOptions {
    val amountVariable0 = if (dataItem.hasKey("amountVariable")) {
        dataItem["amountVariable"].asBoolean
    } else {
        null
    }
    val minAmount0 = if (dataItem.hasKey("minAmount")) {
        dataItem["minAmount"].asDouble
    } else {
        null
    }
    val maxAmount0 = if (dataItem.hasKey("maxAmount")) {
        dataItem["maxAmount"].asDouble
    } else {
        null
    }
    val totalAmount0 = if (dataItem.hasKey("totalAmount")) {
        dataItem["totalAmount"].asDouble
    } else {
        null
    }
    val initialAmount0 = if (dataItem.hasKey("initialAmount")) {
        dataItem["initialAmount"].asDouble
    } else {
        null
    }
    val initialAmountNumber0 = if (dataItem.hasKey("initialAmountNumber")) {
        dataItem["initialAmountNumber"].asNumber
    } else {
        null
    }
    val apr0 = if (dataItem.hasKey("apr")) {
        dataItem["apr"].asDouble
    } else {
        null
    }
    return MitOptions(
        amountVariable = amountVariable0,
        minAmount = minAmount0,
        maxAmount = maxAmount0,
        totalAmount = totalAmount0,
        initialAmount = initialAmount0,
        initialAmountNumber = initialAmountNumber0,
        apr = apr0,
    )
}
